import React from 'react'
import './Electricals.css'
import electric1 from '../../assets/electrical/lighting_1.jpg'
import electric2 from '../../assets/electrical/panel_1.jpg'
import electric3 from '../../assets/electrical/lighting_2.JPG'
import electric4 from '../../assets/electrical/lighting_4.JPG'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation,Autoplay } from 'swiper/modules';
function Electricals() {
  return (
    <>
    <div className='wavy-hero-container'>
                    <img src={electric1} className='wavy-hero-img' alt='hero'/>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className='hero-wave'><path fill="var(--dark)" fill-opacity="1" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,272C1120,277,1280,267,1360,261.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className='hero-wave-1'><path fill="#f6f6f6" fill-opacity="1" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,272C1120,277,1280,267,1360,261.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                    <div className='wavy-title'>
                        <p id='services' data-aos="slide-right">SERVICES</p>

                        <p data-aos="slide-left">ELECTRICAL</p>
                    </div>
    </div>








    <div className='service-intro'>
        <div className='service-intro-container'>
            <div className='service-intro-text'>
                <div data-aos="fade-right" className='service-intro-text-wrapper'>
                    <div className='service-intro-text-title'>The <b>MOST</b> Reliable Electrical Remodeling In DFW </div>
                    <div className='service-intro-text-sub'>Over 50+ Electrical Remodeling Clients in DFW</div>
                    <div className='service-intro-text-p' >Whether you're remodeling an existing space or building new, our comprehensive electrical services cover all aspects of installations and upgrades. From wiring and panel upgrades to installing lighting fixtures and smart home systems, we ensure that your electrical infrastructure is up-to-date and capable of supporting your lifestyle needs. Our expert team works with precision to provide installations that are safe, efficient, and tailored to your specific requirements.</div>
                    <a href='tel:+14697284201'>
                        <button className='service-intro-text-btn'>GET A QUOTE</button>
                    </a>
                </div>
            </div>
            <img src={electric4} data-aos="fade-left" style={{"objectPosition":"top"}} alt='panel'/>
        </div>
    </div>









    <div className='service-cards'>
        <p className='service-cards-title' data-aos="fade">Electrical Services <span className='service-cards-accent'>Tailored to Your Home</span></p>
        <p className='service-cards-subtitle' data-aos="fade">Discover The Many Ways Our Electrical Services Can Improve Your Home</p>
        <div className='service-cards-wrapper'>

            <div className='service-cards-card' data-aos="flip-right">
                <img src={electric1} alt='card 1'/>
                <div className='service-cards-card-title'>Whole-Home Electrical Upgrades: Safety Meets Modern Living</div>
                <div className='service-cards-card-subtitle'>Empowering Your Home: A Seamless Electrical Transformation</div>
                <div className='service-cards-card-p'>Modern living requires reliable, up-to-date electrical infrastructure. Our whole-home upgrades replace outdated panels and wiring with efficient, code-compliant systems designed for today’s energy demands. From increased capacity to future-ready solutions, we ensure your home is powered safely and smartly. With Home Service Experts, you’ll enjoy peace of mind and a home that’s built to keep up with your lifestyle.</div>
            </div>



            <div className='service-cards-card' data-aos="flip-right">
                <img src={electric3} alt='card 2'/>
                <div className='service-cards-card-title'>Custom Lighting Design & Installation: Illuminate with Purpose</div>
                <div className='service-cards-card-subtitle'>Lighting That Inspires: Designed for Function, Tailored for Beauty</div>
                <div className='service-cards-card-p'>Lighting is more than just utility—it’s atmosphere, comfort, and design. We offer custom lighting solutions that elevate each room, combining function with aesthetic appeal. From elegant accent lighting to whole-home LED upgrades, our team works closely with you to illuminate your space exactly how you envision it. With Home Service Experts, you’ll see your home in a whole new light.</div>
            </div>




            <div className='service-cards-card' data-aos="flip-right">
                <img src={electric2} alt='card 3'/>
                <div className='service-cards-card-title'>Panel & Circuit Breaker Upgrades: Power You Can Rely On</div>
                <div className='service-cards-card-subtitle'>Reinforcing Your Home’s Electrical Backbone</div>
                <div className='service-cards-card-p'>Your electrical panel is the heart of your home’s power system. As your energy demands grow—with new appliances, tech, or renovations—your panel needs to keep up. We provide professional panel and circuit breaker upgrades that improve performance, increase safety, and reduce the risk of overloads or outages. With Home Service Experts, your home will be ready for whatever the future brings.</div>
            </div>




        </div>
    </div>









    <div className='service-cta'>
        <div className='service-cta-container'>
            <div className='service-cta-text'>
                <div>
                    <p className='service-cta-text-title' data-aos="fade">Start Your Electrical <b>Upgrade Today</b></p>
                    <p className='service-cta-text-subtitle' data-aos="fade">If you’re ready to upgrade your home’s electrical system, contact Home Service Experts today. Our team would be happy to discuss your project, answer your questions, and provide a free estimate to get things moving.</p>
                </div>
                <a href='tel:+14697284201'>
                    <button className='service-cta-text-button' data-aos="fade">CALL NOW</button>
                </a>
            </div>
            <img className="service-cta-image" alt='service' src={electric3}/>
        </div>
    </div>













    <div className='service-portfolio'>
        <div className='service-portfolio-header'>
            <div className='service-portfolio-header-title' data-aos="fade"><b>Real</b> Projects. <b>Real</b> Results.</div>
            <div className='service-portfolio-header-subtitle' data-aos="fade">Explore our recent electrical projects and get inspired by the difference expert craftsmanship makes. Every home we work on is powered for safety, comfort, and modern living.</div>
        </div>
        <div className='service-portfolio-slides'>
            <Swiper
            breakpoints={{
                1200:{
                    slidesPerView: 3,
                  spaceBetween: 15
                },
                900:{
                    slidesPerView: 2

                },
                550:{
                    slidesPerView: 1,

                    spaceBetween: 15
                }
                ,
                0: {
                //   slidesPerView: 2,

                  spaceBetween: 5
                }
              }}
              freeMode={true}
              navigation={true}
              loop={true}
              autoplay={{
                delay: 5000, // Delay in milliseconds (3 seconds)
                disableOnInteraction: true, // Continue autoplay after user interactions
                pauseOnMouseEnter: true, // Pause autoplay on mouse hover
              }}
              modules={[FreeMode, Pagination, Navigation, Autoplay]}
              style={{padding:"20px"}} data-aos="zoom-in">
                <SwiperSlide>
                    <img src={electric1} alt='electric gallery 1'/>
                </SwiperSlide>
                
                <SwiperSlide>
                    <img src={electric2} alt='electric gallery 2'/>
                </SwiperSlide>
                <SwiperSlide>
                    <img src={electric3} alt='electric gallery 3'/>
                </SwiperSlide>
                <SwiperSlide>
                    <img style={{objectPosition:"top"}} alt='electric gallery 4' src={electric4}/>
                </SwiperSlide>


            </Swiper>
        </div>










    </div>




















    </>
  )
}

export default Electricals